import { Component, OnInit, Input, NgModule } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbTabsetConfig } from '@ng-bootstrap/ng-bootstrap';
import { SpecialityModel } from './speciality.model';

import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MasterService } from '../master.service';
import { HttpClient } from '@angular/common/http';

import * as CommonConstants from '../../utils/common.constants';
import { SharedService } from 'src/app/utils/shared.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-specialities',
  templateUrl: './specialities.component.html',
  styleUrls: ['./specialities.component.scss']
})
export class SpecialitiesComponent implements OnInit {

  @Input() partnerId: number;
  @Input() partnerType: number;

  specialityForm: FormGroup;
  submitted = false;
  departments: any[];
  specList:any[]=[];

  subSpecialityForm: FormGroup;
  specialities: any[];

  subSpecList: any[] = [];
  hyperSpecialityForm: FormGroup;
  
  subSpecialities: any[];
  hyperSpecList: any[] = [];

  
  constructor(private http: HttpClient, private modalService: NgbModal, private formBuilder: FormBuilder, 
    private masterService: MasterService, private sharedService:SharedService, private toastrService:ToastrService, config: NgbTabsetConfig) {
    this.getSpecFormGroup();
    this.getSubSpecFormGroup();
    this.getHyperSpecFormGroup();

    config.justify = 'start';
    config.type = 'pills';
   }

  ngOnInit() {
    this.loadMasterData();
  }


  loadMasterData() {
    this.masterService.getDepartments().subscribe(response => {
      if (response && response['result']) {
        this.departments = response['result'];
      }
    })
  }

  specialityAddModal(addSpeciality) {
    this.modalService.open(addSpeciality, { size: 'lg', container: '.page-content' });
  }
  subSpecialityAddModal(addSubSpeciality){
    this.modalService.open(addSubSpeciality, { size: 'lg', container: '.page-content' });
  }
  hyperSpecialityAddModal(addHyperSpeciality){
    this.modalService.open(addHyperSpeciality, { size: 'lg', container: '.page-content' });
  }

  /**
  * Declare form group
  *  
  */
  private getSpecFormGroup() {
    this.specialityForm = this.formBuilder.group({
      'spltyDescEn': ['', Validators.required],
      'deptmId': new FormControl(),
      'spltyNuNumberBed': new FormControl(),
      'spltyNuNumberSpeciality': new FormControl()
    })
  }
  private getSubSpecFormGroup() {
    this.subSpecialityForm = this.formBuilder.group({
      'ssptyDescEn': ['', Validators.required],
      'spltyId': ['', Validators.required],
      'ssptyNuNumberBed': new FormControl(),
      'ssptyNuNumberSpeciality': new FormControl()
    })
  }
  private getHyperSpecFormGroup() {
    this.hyperSpecialityForm = this.formBuilder.group({
      'hsptyDescEn': ['', Validators.required],
      'spltyId': new FormControl(),
      'ssptyId': new FormControl(),
      'hsptyNuNumberBed': new FormControl(),
      'hsptyNuNumberSpeciality': new FormControl()
    })
  }

  /**
   * To get form controls
   */
  get f() { return this.specialityForm.controls; }
 // get f() { return this.subSpecialityForm.controls; }
 // get f() { return this.hyperSpecialityForm.controls; }

 saveSpeciality() {
  this.submitted = true;
  if (this.specialityForm.invalid) {
    return;
  }
  let saveData = this.specialityForm.value;
  saveData['partnerId'] = this.partnerId;
  saveData['partnerType'] = this.partnerType;
  if (this.specialityForm.value) {
    this.http.post(CommonConstants.SAVE_PARTNER_SPECIALITY, saveData)
      .subscribe(response => {
        if (response['code'] == 0) {
          this.toastrService.success("saved");
          this.specList = this.sharedService.updateDuplicateRecord(response['result'], this.specList, "spetyId", this.specialityForm.value);
          this.modalService.dismissAll("#addSpeciality");
          this.specList =this.specList.map(item => ({ ...item, 
            deptName: item.deptmId ? this.departments.find(obj => +obj.deptmId === +item.deptmId).deptmNameEn : null, 
            spltyName: item.spltyId ? this.specialities.find(obj => +obj.spltyId === +item.spltyId).spltyDescEn: null})); 
        }
      })
  }
}

editSpeciality(spec, addSpec) {
  this.modalService.open(addSpec, { size: 'lg', container: '.page-content' });
  this.specialityForm.patchValue({
    spltyDescEn: spec['spltyDescEn']
    // formControlName2: myValue2 (can be omitted)
  });
}

 
  
saveSubSpeciality() {
  this.submitted = true;
  if (this.subSpecialityForm.invalid) {
    return;
  }
  let saveData = this.subSpecialityForm.value;
  saveData['partnerId'] = this.partnerId;
  saveData['partnerType'] = this.partnerType;
  if (this.specialityForm.value) {
    this.http.post(CommonConstants.SAVE_PARTNER_SPECIALITY, saveData)
      .subscribe(response => {
        if (response['code'] == 0) {
          this.toastrService.success("saved");
          this.specList = this.sharedService.updateDuplicateRecord(response['result'], this.specList, "spetyId", this.subSpecialityForm.value);
          this.modalService.dismissAll("#addSpeciality");
          this.specList =this.specList.map(item => ({ ...item, 
            deptName: item.deptmId ? this.departments.find(obj => +obj.deptmId === +item.deptmId).deptmNameEn : null, 
            spltyName: item.spltyId ? this.specialities.find(obj => +obj.spltyId === +item.spltyId).spltyDescEn: null})); 
        }
      })
  }
}

editSubSpeciality(spec, addSpec) {
  this.modalService.open(addSpec, { size: 'lg', container: '.page-content' });
  this.subSpecialityForm.patchValue({
    spltyDescEn: spec['spltyDescEn']
    // formControlName2: myValue2 (can be omitted)
  });
}


saveHyperSpeciality() {
  this.submitted = true;
  if (this.hyperSpecialityForm.invalid) {
    return;
  }
  let saveData = this.hyperSpecialityForm.value;
  saveData['partnerId'] = this.partnerId;
  saveData['partnerType'] = this.partnerType;
  if (this.hyperSpecialityForm.value) {
    this.http.post(CommonConstants.SAVE_PARTNER_SPECIALITY, saveData)
      .subscribe(response => {
        if (response['code'] == 0) {
          this.toastrService.success("saved");
          this.specList = this.sharedService.updateDuplicateRecord(response['result'], this.specList, "spetyId", this.hyperSpecialityForm.value);
          this.modalService.dismissAll("#addSpeciality");
          this.specList =this.specList.map(item => ({ ...item, 
            deptName: item.deptmId ? this.departments.find(obj => +obj.deptmId === +item.deptmId).deptmNameEn : null, 
            spltyName: item.spltyId ? this.specialities.find(obj => +obj.spltyId === +item.spltyId).spltyDescEn: null})); 
        }
      })
  }
}

editHyperSpeciality(spec, addSpec) {
  this.modalService.open(addSpec, { size: 'lg', container: '.page-content' });
  this.hyperSpecialityForm.patchValue({
    spltyDescEn: spec['spltyDescEn']
    // formControlName2: myValue2 (can be omitted)
  });
}
  

}
